import { render, staticRenderFns } from "./NormalSearchNav64.vue?vue&type=template&id=0864ac36&scoped=true"
import script from "./NormalSearchNav64.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav64.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0864ac36",
  null
  
)

export default component.exports